import { MenuItem } from '@headlessui/react';
import useAppContext from 'flow/hooks/useAppContext';
import { TabParams } from 'flow/types/TabParams';
import { twMerge } from 'tailwind-merge';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { MenuItem as MenuItemTypes } from '../ui-components/ToolbarMenu';
import Icon from '../ui-components/Icon';

interface Props {
    menuItems: MenuItemTypes[];
    handleClose: () => void;
}

const FlowListMenu = ({ menuItems, handleClose }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { tab } = useParams<TabParams>();

    return (
        <div className="w-52 p-2">
            {menuItems.map((item) => (
                <MenuItem key={`list-${item.key}`}>
                    <div
                        data-test-id={`drawer-menu-${item.key}`}
                        onClick={() => {
                            history.push(item.route);
                            handleClose();
                        }}
                        className={twMerge(
                            'flex cursor-pointer items-center justify-between rounded-sm p-2 hover:bg-gray-200',
                            tab === item.key ? 'bg-gray-200' : null,
                        )}
                    >
                        <div className="flex items-center gap-x-2">
                            <Icon
                                iconKey={item.iconKey}
                                className="text-gray-600"
                            />

                            <div>{i18next.t(`route.${item.key}`)}</div>
                        </div>

                        {item.badgeCounter ? (
                            <div className="bg-red text-2xs flex size-5 items-center justify-center rounded-full text-white">
                                {item.badgeCounter}
                            </div>
                        ) : null}
                    </div>
                </MenuItem>
            ))}
        </div>
    );
};

export default FlowListMenu;
